import _ from "lodash";
import cloneDeep from "lodash/cloneDeep";
import fieldFormatter from "./fieldFormatter";

export const deepClone = obj => cloneDeep(obj);

export const getLeafColumns = (columns, excludes) => {
  const leafs = (t = {}) => (t.columns ? t.columns.flatMap(leafs) : [t]);

  const leafColumns = leafs({ columns });
  return leafColumns
    .filter(column => !excludes || excludes.length === 0 || !excludes.includes(column.accessor));
};

export const configuredReportList = (perReportConfiguration) => {
  const reportList = [];
  perReportConfiguration.forEach(eachConfig => reportList.push({ reportId: eachConfig.reportCode, maxSize: eachConfig.config.maxRowsForExcelExport }));
  return reportList;
};

export const reorderArrayWithTemplate = (arrayToReorder, reorderingTemplate) => {
  const reorderedArray = [];
  reorderingTemplate.forEach(originalIndex => reorderedArray.push(arrayToReorder[originalIndex]));
  return reorderedArray;
};

export const filterArrayWithTemplate = (arrayToFilter, filteringTemplate) => {
  const filteredArray = [];
  filteringTemplate
    .filter(templateItem => templateItem.filtered)
    .forEach(templateItem => filteredArray.push(arrayToFilter[templateItem.originalIndex]));
  return filteredArray;
};

export const setPropertyValueByPath = (obj, path, value) => {
  const a = path.split('.');
  let o = obj;
  while (a.length - 1) {
    const n = a.shift();
    if (!(n in o)) o[n] = {};
    o = o[n];
  }
  o[a[0]] = value;
};

export const getPropertyValueByPath = (obj, path) => {
  // eslint-disable-next-line no-param-reassign
  path = path.replace(/\[(\w+)\]/g, '.$1');
  // eslint-disable-next-line no-param-reassign
  path = path.replace(/^\./, '');
  const a = path.split('.');
  let o = obj;
  while (a.length) {
    const n = a.shift();
    if (!(n in o)) return;
    o = o[n];
  }
  // eslint-disable-next-line consistent-return
  return o;
};

export const getNodeAtPath = (obj, path) => {
  const pathNodes = path.split('.');
  let pathNodeStation = obj;
  // eslint-disable-next-line no-return-assign
  pathNodes.forEach(pNode => pathNodeStation = pathNodeStation[pNode]);
  return pathNodeStation;
};

const STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
const ARGUMENT_NAMES = /([^\s,]+)/g;
export const getParamNames = (func) => {
  const fnStr = func.toString().replace(STRIP_COMMENTS, '');
  let result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
  if (result === null) { result = []; }
  return result;
};

export const hasParamByName = (func, paramName) => getParamNames(func).some(f => f === paramName);

export const createCsvExportFromTableSelection = (clipboard, columns, data, columnSplitter = '\t', rowSplitter = '\n') => {
  const selectionArray = [];

  // eslint-disable-next-line global-require
  const os = require('os');
  if (os.platform().startsWith('win')) {
    // eslint-disable-next-line no-param-reassign
    rowSplitter = '\r\n';
  }

  const headers = [];
  const leafColumns = getLeafColumns(columns);

  clipboard.th
    .forEach((th) => {
      const columnHeader = leafColumns.find(column => column.accessor === th);
      headers.push(columnHeader.Header);
    });
  selectionArray.push(headers.join(columnSplitter).concat(rowSplitter));

  // eslint-disable-next-line no-use-before-define
  clipboard.tr.forEach(tr => selectionArray.push(createCsvExportFromTableRowSelection(tr, clipboard.th, columns, data, columnSplitter, rowSplitter)));

  return selectionArray.join(rowSplitter);
};

export const createCsvExportFromTableRowSelection = (tr, ths, columns, data, columnSplitter, rowSplitter) => {
  const leafColumns = getLeafColumns(columns);
  let groupMemberCount = 1;
  // eslint-disable-next-line no-unused-vars
  ths.forEach((th, i) => {
    const value = getPropertyValueByPath(data[tr], th);
    if (Array.isArray(value)) {
      groupMemberCount = value.length;
    }
  });

  const rowGroup = [];
  ths.forEach((th) => {
    const columnHeader = leafColumns.find(column => column.accessor === th);
    const rawValue = getPropertyValueByPath(data[tr], th);
    let valueItem = rawValue;
    if (Array.isArray(valueItem)) {
      if (columnHeader.Cell && columnHeader.Cell.name) {
        valueItem = fieldFormatter(columnHeader.Cell.name).apply(null, [{ value: rawValue }]);
        valueItem = valueItem.map(div => div.props.children);
      }
    }
    rowGroup.push(valueItem);
  });

  const rowGroupExport = [];
  _.range(0, groupMemberCount, 1)
    .forEach((i) => {
      const aRow = [];
      rowGroup.forEach((v) => {
        if (Array.isArray(v)) {
          // eslint-disable-next-line no-useless-escape
          aRow.push(v[i] ? `\"${v[i].toString()}\"` : '');
        } else if (i === 0) {
          // eslint-disable-next-line no-useless-escape
          aRow.push(v ? `\"${v.toString()}\"` : '');
        } else {
          aRow.push('');
        }
      });
      rowGroupExport.push(aRow.join(columnSplitter));
    });

  return rowGroupExport.join(rowSplitter);
};

export const createPresetSelections = (selections, parentNodes) => {
  const finalSelections = [];
  selections
    .filter(element => !element.endsWith("*"))
    .forEach(element => finalSelections.push(element));

  selections
    .filter(element => element.endsWith("*"))
    .map(element => element.substring(0, element.indexOf('*')))
    .forEach((element) => {
      // eslint-disable-next-line no-shadow
      const parentNode = parentNodes.find(parentNode => parentNode.value.endsWith(element));
      if (parentNode) {
        parentNode.children.map(childNode => childNode.value).forEach(nodeValue => finalSelections.push(nodeValue));
      }
    });

  return finalSelections;
};

export const createPresetSelectionsOnSave = (selections, parentNodes) => {
  const selectionsCopied = Array.from(selections);
  const selectionsToSave = [];
  parentNodes
    .filter(parentNode => parentNode.value.startsWith("J1C"))
    .filter(parentNode => parentNode.children.map(childNode => childNode.value).every(v => selections.includes(v)))
    .forEach((parentNode) => {
      parentNode.children
        .map(childNode => childNode.value)
        .forEach(childNodeValue => selectionsCopied.splice(selectionsCopied.indexOf(childNodeValue), 1));
      selectionsToSave.push(`${parentNode.value.substring(3)}*`);
    });
  selectionsCopied.forEach(s => selectionsToSave.push(s));
  return selectionsToSave;
};

export const createUnlocodePresetSelectionsOnSave = (selections, parentNodes) => {
  const selectionsCopied = Array.from(selections);
  const selectionsToSave = [];
  parentNodes
    .filter(parentNode => parentNode.children.map(childNode => childNode.value).every(v => selections.includes(v)))
    .forEach((parentNode) => {
      parentNode.children
        .map(childNode => childNode.value)
        .forEach(childNodeValue => selectionsCopied.splice(selectionsCopied.indexOf(childNodeValue), 1));
      selectionsToSave.push(`${parentNode.value}*`);
    });
  selectionsCopied.forEach(s => selectionsToSave.push(s));
  return selectionsToSave;
};

export const createProductPresetSelections = (selections, mailClassNodes) => {
  const finalSelections = [];

  selections
    .filter(element => element.mailSubClasses.includes('**'))
    .forEach((element) => {
      const allMailSubClasses = [];
      mailClassNodes.forEach((mcn) => {
        mcn.children.forEach(msc => allMailSubClasses.push(msc.value));
      });
      finalSelections.push({
        mailCategoryCode: element.mailCategoryCode,
        mailSubClasses: allMailSubClasses,
      });
    });

  selections
    .filter(element => !element.mailSubClasses.includes('**'))
    .forEach((element) => {
      const transformedMailSubClasses = [];
      element.mailSubClasses
        .filter(msc => msc.endsWith("*"))
        .forEach((msc) => {
          const mailClassNode = mailClassNodes.find(mcn => mcn.value.endsWith(msc.substring(0, 1)));
          if (mailClassNode) {
            mailClassNode.children.forEach(msc1 => transformedMailSubClasses.push(msc1.value));
          }
        });

      element.mailSubClasses
        .filter(msc => !msc.endsWith("*"))
        .forEach(msc => transformedMailSubClasses.push(msc));

      finalSelections.push({
        mailCategoryCode: element.mailCategoryCode,
        mailSubClasses: transformedMailSubClasses,
      });
    });
  return finalSelections;
};

export const createProductPresetSelectionsOnSave = (selections, mailClassNodes) => {
  const selectionsToSave = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const [category, mailSubClassSelections] of Object.entries(selections)) {
    // eslint-disable-next-line no-use-before-define
    const classLevelSelections = createCategoryLevelProductPresetSelectionsOnSave(mailSubClassSelections.selected, mailClassNodes);
    if (classLevelSelections && classLevelSelections.length > 0) {
      if (mailClassNodes.map(mcn => mcn.value).every(v => classLevelSelections.includes(`${v}*`))) {
        selectionsToSave.push({
          mailCategoryCode: category,
          mailSubClasses: ['**'],
        });
      } else {
        selectionsToSave.push({
          mailCategoryCode: category,
          mailSubClasses: classLevelSelections,
        });
      }
    }
  }

  return selectionsToSave;
};

export const createCategoryLevelProductPresetSelectionsOnSave = (mailSubClassSelections, mailClassNodes) => {
  const selectionsCopied = Array.from(mailSubClassSelections);
  const selectionsToSave = [];
  mailClassNodes
    .filter(parentNode => parentNode.children.map(childNode => childNode.value).every(v => mailSubClassSelections.includes(v)))
    .forEach((parentNode) => {
      parentNode.children
        .map(childNode => childNode.value)
        .forEach(childNodeValue => selectionsCopied.splice(selectionsCopied.indexOf(childNodeValue), 1));
      selectionsToSave.push(`${parentNode.value}*`);
    });
  selectionsCopied.forEach(s => selectionsToSave.push(s));
  return selectionsToSave;
};

export const compareReportCategoriesForReportMenu = (a, b) => {
  if (a.displaySeqReportMenu === 0) {
    if (b.displaySeqReportMenu === 0) {
      return a.reportCategoryGroupId - b.reportCategoryGroupId || a.displaySequence - b.displaySequence;
    }
    return 1;
  }
  if (b.displaySeqReportMenu === 0) {
    return -1;
  }
  if (a.displaySeqReportMenu === b.displaySeqReportMenu) {
    return a.reportCategoryGroupId - b.reportCategoryGroupId || a.displaySequence - b.displaySequence;
  }
  return a.displaySeqReportMenu - b.displaySeqReportMenu;
};

export const compareReportCategoriesForGroup = (a, b) => a.displaySequence > b.displaySequence;

export const isMainReportCategory = (reports, reportCategory) =>
  reportCategory.hasReports
    && reports.some(r => r.reportCategory && r.reportCategory.categoryId === reportCategory.categoryId);
